import constants from "constants/constants";
import {
  DEFAULT_PAYMENT_CYCLE,
  PAYMENT_PLAN_TYPE,
  PRICING_MODE_KEYS,
  schedule_types_ids,
} from "constants/schedule";
import { isInteger, is_empty } from "utils/validations";
import { NUMERIC_REGEX } from "constants/regExpPatterns";
import { SLOT_LISTING_TYPES } from "features/Listings/constants/Listings.constants";
export { SLOT_LISTING_TYPES } from "features/Listings/constants/Listings.constants";

export const isClassType = (type) => {
  return (
    type === constants?.scheduleTypesId?.group_class ||
    type === constants?.scheduleTypesId?.one_on_one_class ||
    type === constants?.scheduleTypesId?.rolling_class
  );
};

export const isCommunityType = (type) => {
  return (
    type === constants?.scheduleTypesId?.branded_community ||
    type === constants?.scheduleTypesId?.whatsapp ||
    type === constants?.scheduleTypesId?.telegram
  );
};

// Branded Community offering (not WhatsApp/Telegram communities)
export const isBrandedCommunityOffering = (type) => {
  return type === constants?.scheduleTypesId?.branded_community;
};

export const isQpp = (type) => {
  return type === constants.scheduleTypesId.no_schedule;
};

export const isTelegramCommunity = (type) => {
  return type === constants.scheduleTypesId.telegram;
};

export const isWebinar = (type) => {
  return type === constants.scheduleTypesId.webinar;
};

export const isMerchandise = (type) => {
  return type === constants.scheduleTypesId.merchandise;
};

/**
 *
 * @param {*} offering object containing type and  course_end_magnitude key and pricing_mode
 * @returns whether the offering has renewal payment type
 */
export const isSubscriptionPaymentType = (offering) => {
  if (is_empty(offering)) {
    return false;
  }

  if (
    !isQpp(offering?.type) &&
    !isCommunityType(offering?.type) &&
    !isClassType(offering?.type)
  ) {
    return false;
  } else if (isQpp(offering?.type) || isCommunityType(offering?.type)) {
    return (
      isInteger(offering?.course_end_magnitude) &&
      offering?.course_end_magnitude > DEFAULT_PAYMENT_CYCLE
    );
  } else if (isClassType(offering?.type)) {
    return (
      isInteger(offering?.pricing_mode) &&
      offering?.pricing_mode === PRICING_MODE_KEYS.monthly
    );
  }

  return false;
};

/**
 *
 * @param {*} offering offering object containing type and  course_end_magnitude key and pricing_mode
 * @returns whether the offering's access can be extended
 */
export const isExtendibleAccessType = (offering) =>
  isFlexibleOneTime(offering) || isSubscriptionPaymentType(offering);

/**
 *
 * @param {*} offering offering object containing type and  course_end_magnitude key
 * @returns whether the offering is qpp with subscription type
 */
export const isQppSubscription = (offering) =>
  isQpp(offering?.type) && isSubscriptionPaymentType(offering);

/**
 *
 * @param {*} offering offering object containing type and  course_end_magnitude key
 * @returns whether the offering is qpp with subscription type
 */
export const isTelegramSubscription = (offering) =>
  isTelegramCommunity(offering?.type) && isSubscriptionPaymentType(offering);

/**
 *
 * @param {*} offering offering object containing type and  pricing_mode key
 */
export const isFlexibleOneTime = (offering) => {
  return (
    offering?.type === schedule_types_ids.rolling_class &&
    offering?.pricing_mode === PRICING_MODE_KEYS.oneTime &&
    offering?.payment_plan_type !== PAYMENT_PLAN_TYPE.SUBSCRIPTIONS
  );
};

export const isBrandedSubscription = (offering) =>
  isBrandedCommunityOffering(offering?.type) &&
  isSubscriptionPaymentType(offering);

export const isNumericListingId = (id) => {
  if (!id || id === "0") return false;
  if (typeof id === "number" && !isNaN(id) && id > 0) return true;
  if (
    typeof id === "string" &&
    NUMERIC_REGEX.test(id.trim()) &&
    Number(id.trim()) > 0
  )
    return true;
  return false;
};

export const isSlotListingType = (offering) => {
  const type = typeof offering === "object" ? offering?.type : offering;
  return SLOT_LISTING_TYPES.includes(type);
};

export const isContentType = (type) => {
  return (
    type === constants?.scheduleTypesId?.content ||
    type === schedule_types_ids.content
  );
};

export const hasRecordingOrSlotType = (listing) => {
  return Boolean(
    listing?.share_recording ||
      listing?.recording_accessibility ||
      isSlotListingType(listing?.type)
  );
};

export const shouldHideUnmappedRecordings = (listing) => {
  if (listing?.metadata?.zoom_recording) return false;
  if (hasRecordingOrSlotType(listing)) {
    return false;
  }
  return true;
};
